import { createColumnHelper } from '@tanstack/react-table';
import { TableMetaCustom } from '@app/types/overrides/table-meta';
import MainTableRowActions from '@components/MainTable/MainTableRowActions';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import {
  IconPencil,
  IconTrash,
  IconArrowNarrowUp,
  IconArrowNarrowDown,
} from '@tabler/icons-react';
import { UseCaseGroup } from '@api/use-case-group';

const columnHelper = createColumnHelper<UseCaseGroup>();

export const useCaseGroupTableColumns = [
  columnHelper.accessor('name', {
    id: 'name',
    header: 'Name',
    enableSorting: true,
    // Give the name column more horizontal space so values don't feel cramped
    size: 260,
    enableResizing: false,
  }),
  columnHelper.accessor('id', {
    id: 'id',
    header: 'Actions',
    enableSorting: false,
    enableResizing: false,
    // Provide enough width so all action icons fit within this column
    size: 140,
    cell: ({
      row: { original },
      table: {
        options: { meta },
      },
    }) => {
      const tableMeta = meta as TableMetaCustom<typeof original> & {
        handleMoveUp?: (row: typeof original) => void;
        handleMoveDown?: (row: typeof original) => void;
      };

      return (
        <MainTableRowActions>
          <>
            <Tooltip title="Move Up">
              <IconButton
                size="small"
                onClick={() => {
                  tableMeta?.handleMoveUp && tableMeta?.handleMoveUp(original);
                }}
              >
                <IconArrowNarrowUp />
              </IconButton>
            </Tooltip>
            <Tooltip title="Move Down">
              <IconButton
                size="small"
                onClick={() => {
                  tableMeta?.handleMoveDown &&
                    tableMeta?.handleMoveDown(original);
                }}
              >
                <IconArrowNarrowDown />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit Use Case Group">
              <IconButton
                onClick={() => {
                  tableMeta?.handleEditRow &&
                    tableMeta?.handleEditRow(original);
                }}
              >
                <IconPencil />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete Use Case Group">
              <IconButton
                onClick={() => {
                  tableMeta?.handleDeleteRow &&
                    tableMeta?.handleDeleteRow(original);
                }}
              >
                <IconTrash />
              </IconButton>
            </Tooltip>
          </>
        </MainTableRowActions>
      );
    },
  }),
];
